// src/lib/abrirSolicitacao.ts
//
// Abre o modal de uma Solicitação por cima da tela atual, sem navegar — ver
// views/Tarefas/SolicitacaoModalGlobal.tsx, que escuta esse evento e está sempre montado
// (App.tsx > MainLayout).
export const ABRIR_SOLICITACAO_EVENTO = 'vigorhub:open-solicitacao';

export interface AbrirSolicitacaoDetail {
  id: string;
}

export const abrirSolicitacao = (id: string): void => {
  window.dispatchEvent(new CustomEvent<AbrirSolicitacaoDetail>(ABRIR_SOLICITACAO_EVENTO, { detail: { id } }));
};

// Reconhece um link de notificação no formato "/tarefas/solicitacoes?id=N" — o que
// views/Tarefas/TarefasView.tsx grava desde o fix de 2026-09-09 e o que os triggers SQL também
// escrevem (ver supabase/migrations/20260814135118_solicitacao_aviso_prazo_proximo.sql e
// 20260814151448_solicitacoes_ti_consolidado_14082026.sql) — e devolve o id, ou null se o link
// não for desse formato. Usado por src/components/NotificationDropdown.tsx pra decidir se abre
// pelo evento acima (sem navegar) em vez de seguir o link de verdade. Detectar pelo FORMATO do
// link (não por notification.type) cobre de graça as notificações já gravadas no banco antes
// desta mudança — não precisa de nenhuma migration.
export const idDaSolicitacaoNoLink = (link: string | null | undefined): string | null => {
  if (!link) return null;
  const match = link.match(/^\/tarefas\/solicitacoes\?id=([^&]+)$/);
  return match ? decodeURIComponent(match[1]) : null;
};
